import { PipeSeparator } from './pipe-separator.component.js';
export { PipeSeparator } from './pipe-separator.component.js';
import { deprecatedComponent } from '../core/deprecated-component.js';

const PipeDivider = deprecatedComponent({
    displayName: 'PipeDivider',
    root: PipeSeparator,
    description: 'Use PipeSeparator component Instead'
});

export { PipeDivider };
